<template>
  <img v-if="!!src" class="ui-icon nio-invisible nio-internal" :class="[roll ? 'roll' : '']" :src="src"
       @click="$emit('click')" />
  <i class="ui-icon" :class="[roll ? 'roll' : '', name]" v-else @click="$emit('click')"></i>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    /** iconfont 名称 */
    name: {
      type: String,
      default: ''
    },
    /** 是否旋转 */
    roll: {
      type: Boolean,
      default: false
    },
    /** 图标icon 图片url */
    src: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes roll {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ui-icon {
  display: inline-block;
  width: inherit;
  // font-family: "nio iconfont" !important;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  vertical-align: middle;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &.roll {
    animation-name: roll;
    animation-duration: 0.9s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
  }
}
</style>